<template>
  <b-container fluid>
    <admin-preloader :show="loading"/>
    <admin-breadcrumb name="Companies"/>
    <b-row>
      <b-col cols="12">
        <admin-panel title="Companies" sub-title="Manage all companies registered in GreenLists" with-footer>
          <admin-companies-table :companies="companies" :sort-by="sortBy" :sort-desc="sortDesc" @sort-changed="onSortChanged"/>
          <template v-slot:header-right>
            <b-form-select
                class="w-auto"
                v-model="filters.tier_level"
                :options="tierLevelOptions"
                @change="() => loadCompanies()"
            />
            <b-form-select
                class="w-auto  ml-2"
                v-model="filters.status"
                :options="statusOptions"
                @change="() => loadCompanies()"
            />
          </template>
          <template v-slot:footer>
            <b-pagination
                v-model="page"
                :total-rows="total_in_pages"
                :per-page="per_page"
                @change="loadCompanies"
                align="center"
                class="admin-pagination mb-0"
            ></b-pagination>
          </template>
        </admin-panel>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import AdminPanel from "../components/AdminPanel";
import AdminBreadcrumb from "../components/AdminBreadcrumb";
import {API_ROUTES} from "../api";
import AdminCompaniesTable from "../components/AdminCompaniesTable";
import AdminPreloader from "../components/AdminPreloader";

export default {
  name: "AdminCompanies",
  components: {AdminPreloader, AdminCompaniesTable, AdminBreadcrumb, AdminPanel},
  data() {
    return {
      companies: [],
      loading: true,
      page: 1,
      per_page: 10,
      total_in_pages: 0,
      filters: {
        status: '',
        tier_level: ''
      },
      sortBy: 'date_added',
      sortDesc: false,
    }
  },
  computed: {
    search() {
      return this.$store.state.current.search;
    },
    statusOptions() {
      let options = this.$store.state.data.company_statuses.map(status => ({
        text: status.name,
        value: status.id
      }));
      options.unshift({
        text: 'All Statuses',
        value: ''
      });

      return options;
    },
    tierLevelOptions() {
      let options = [{
        text: 'All Tier Levels',
        value: ''
      }];
      for (let i = 1; i <= 10; i++) {
        options.push({
          text: `Tier Level: ${i}`,
          value: i
        });
      }

      return options;
    }
  },
  watch: {
    search() {
      this.loadCompanies();
    }
  },
  methods: {
    onSortChanged({ sortBy, sortDesc }) {
      this.sortBy = sortBy;
      this.sortDesc = sortDesc;

      // Save to localStorage
      const sorting = sortDesc ? 'last_created' : 'first_created';
      localStorage.setItem('company_sorting', sorting);

      this.loadCompanies(1);
    },
    loadCompanies(page = 1) {
      this.loading = true;
      let params = {
        page: page,
        per_page: this.per_page
      };
      if (this.search) {
        params['search'] = this.search;
      }
      if (this.filters.status) {
        params['status'] = this.filters.status;
      }
      if (this.filters.tier_level) {
        params['tier_level'] = this.filters.tier_level;
      }

      const sorting = this.sortDesc ? 'last_created' : 'first_created';
      params['sorting'] = sorting;

      this.$api.get(API_ROUTES.ADMIN_COMPANIES, {
        params: params
      }).then(({data}) => {
        this.companies = data.companies;
        this.total_in_pages = data.meta.total;
      }).catch(({response}) => {

      }).finally(() => {
        if (page !== this.page) {
          this.page = page;
        }
        this.loading = false;
      });
    }
  },
  created() {
    const sort = localStorage.getItem('company_sorting');
    if (sort === 'last_created') this.sortDesc = true;
    if (sort === 'first_created') this.sortDesc = false;

    this.loadCompanies();
  }
}
</script>
